import { eur } from "@/lib/format";
import { num, normCond } from "./utils";

const pc = (n) => `${num(n).replace(/,00$/, "")} %`;

function liquidacion(t) {
  const cd = normCond(t.condiciones);
  return [
    ["Ejecución material del periodo", t.ejecucion_periodo, "liq-ejecucion"],
    ...(cd.gg_pct ? [[`+ Gastos generales (${pc(cd.gg_pct)})`, t.gg_importe, "liq-gg"]] : []),
    ...(cd.bi_pct ? [[`+ Beneficio industrial (${pc(cd.bi_pct)})`, t.bi_importe, "liq-bi"]] : []),
    ...(cd.baja_pct ? [[`− Baja de adjudicación (${pc(cd.baja_pct)})`, -t.baja_importe, "liq-baja"]] : []),
    ["Base imponible", t.base_periodo, "total-base", true],
    cd.isp ? ["IVA: inversión del sujeto pasivo", 0, "liq-iva"] : [`+ IVA (${pc(cd.iva_pct)})`, t.iva_periodo, "liq-iva"],
    ...(t.irpf_periodo ? [[`− Retención IRPF (${pc(cd.irpf_pct)})`, -t.irpf_periodo, "liq-irpf"]] : []),
  ];
}

function Fila({ l, v, id, fuerte }) {
  return (
    <div className={`flex justify-between gap-3 py-1 text-sm ${fuerte ? "border-t border-slate-200 font-semibold text-slate-900" : "text-slate-600"}`}>
      <span>{l}</span><span className="font-mono-num" data-testid={id}>{eur(v)}</span>
    </div>
  );
}

export function TotalesCert({ t, prefijo = "cert", totalId = "cert-total-periodo" }) {
  const cd = normCond(t.condiciones);
  const origen = [["Presupuesto", t.base_presupuesto], ["Certificado anterior", t.base_anterior], ["Certificado a origen", t.base_origen], ["Pendiente de certificar", t.pendiente_certificar]];
  return (
    <div className="grid gap-4 lg:grid-cols-2" data-testid={`${prefijo}-totales`}>
      <div className="grid grid-cols-2 content-start gap-3 rounded-xl border border-slate-200 bg-slate-50/60 p-4">
        <p className="col-span-2 text-[11px] font-bold uppercase tracking-wide text-[#007F91]">Resumen a origen</p>
        {origen.map(([l, v]) => <div key={l}><p className="text-[11px] text-slate-500">{l}</p><p className="font-mono-num text-sm font-semibold text-slate-900">{eur(v)}</p></div>)}
      </div>
      <div className="rounded-xl border border-slate-200 p-4">
        <p className="mb-1 text-[11px] font-bold uppercase tracking-wide text-[#007F91]">Liquidación de esta certificación</p>
        {liquidacion(t).map(([l, v, k, fuerte]) => <Fila key={k} l={l} v={v} id={`${prefijo}-${k}`} fuerte={fuerte} />)}
        <div className="mt-2 flex items-center justify-between gap-3 rounded-lg bg-[#1B2B4B] px-3 py-2 text-white">
          <span className="text-sm">Total de esta certificación</span><span className="font-mono-num text-lg font-bold" data-testid={totalId}>{eur(t.total_periodo)}</span>
        </div>
        {t.retencion_importe > 0 && (
          <>
            <Fila l={`− Retención de garantía (${pc(cd.retencion_pct)})`} v={-t.retencion_importe} id={`${prefijo}-liq-retencion`} />
            <div className="flex items-center justify-between gap-3 rounded-lg bg-[#00B4CC] px-3 py-2 text-white">
              <span className="text-sm font-semibold">Líquido a percibir</span><span className="font-mono-num text-lg font-bold" data-testid={`${prefijo}-liquido`}>{eur(t.liquido)}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
